import { applyMiddleware } from 'redux'
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk'
// import axios from 'axios'
// import moment from 'moment'
// import config from './config'

// const API_ROOT = config.API_ROOT

// const SYNC_TRIGGERS = {
//   TIMELINE_JUMP: 'TIMELINE_JUMP',
//   TIMELINE_FORWARD: 'TIMELINE_FORWARD',
//   TIMELINE_BACKWARD: 'TIMELINE_BACKWARD',
// }

// const syncTimeline = store => next => action => {
//   const result = next(action)
//   const { user: { id }, timeline } = store.getState()
//   // const refreshDay = moment(timeline.selectedDay).format('YYYY-MM-DD')
//   const nextDayToRetrieve = moment(timeline.selectedDay).add(1, 'days').format('YYYY-MM-DD')
//   const prevDayToRetrieve = moment(timeline.selectedDay).subtract(1, 'days').format('YYYY-MM-DD')
//   let dayToRetrieve = timeline.selectedDay
//   if(SYNC_TRIGGERS[action.type] === 'TIMELINE_FORWARD' && timeline.timeline[timeline.selectedDay] && ! timeline.timeline[nextDayToRetrieve]) {
//     dayToRetrieve = moment(nextDayToRetrieve).add(1, 'days').format('YYYY-MM-DD')
//   }
//   else if(SYNC_TRIGGERS[action.type] === 'TIMELINE_BACKWARD' && timeline.timeline[timeline.selectedDay] && !timeline.timeline[prevDayToRetrieve])
//     dayToRetrieve = moment(prevDayToRetrieve).subtract(1, 'days').format('YYYY-MM-DD')

//   if(!SYNC_TRIGGERS[action.type] || timeline.timeline[dayToRetrieve] || timeline.isLoading)
//     return result

//   store.dispatch({ type: 'GET_TRACKER_DATA', dateString: dayToRetrieve })
//   new Promise((resolve, reject) => {
//     axios.get(API_ROOT + '/tracker2/' + id + '/' + dayToRetrieve, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
//     .then((res) => { 
//       store.dispatch({ type: 'GET_TRACKER_DATA_FULFILLED', payload: res.data })
//       resolve(res) 
//     })
//     .catch((err) => { 
//       reject(err) 
//     })
//   })

//   return result
// }

export default applyMiddleware(promise, thunk)
